module.exports = __webpack_public_path__ + "media/app/assets/races/dracthyr_female-7fc5565520dbe511597e7176d3d002be.png";